import React from 'react'

const Loading = (props) => {

    return (
        <h1>Loading...</h1>
    )

}

export default Loading